import moment from "moment";

export default {
    getLocale() {
        return localStorage.getItem("profile-locale") || "de";
    },

    setLocale(locale) {
        if (!locale) return;
        localStorage.setItem("profile-locale", locale);

        const primary = String(locale).split(/[-_]/)[0];
        moment.locale(primary);
    },

    init() {
        const primary = this.getLocale().split(/[-_]/)[0];
        moment.locale(primary);
    },

    format(date, format = "L LTS") {
        const locale = localStorage.getItem("profile-locale") || "de";
        moment.locale(locale.split(/[-_]/)[0]);
        return moment(date).format(format);
    },
    
    isValidDate(value) {
        if (value == null || value === "") return false;
        const d = new Date(value);
        return !isNaN(d.getTime());
    },
    
    diff(date, unit = "ms") {
        const now = Date.now();
        const target = new Date(date).getTime();
        const diffMs = now - target;

        switch (unit) {
            case "ms":
            return diffMs;
            case "seconds":
            return Math.floor(diffMs / 1000);
            case "minutes":
            return Math.floor(diffMs / (1000 * 60));
            case "hours":
            return Math.floor(diffMs / (1000 * 60 * 60));
            case "days":
            return Math.floor(diffMs / (1000 * 60 * 60 * 24));
            default:
            return diffMs; // fallback
        }
    }


};
